export default {
  groupManagement: {
    addGroup:'新建群组',
    tabtext1:'群组查询',
    tabtext2:'群组标签',
    tabtext3:'进群问题',

    groupId:'群ID',
    leaderId:'群主ID',
    user_id:'用户靓号',

    avatar:'群头像',
    groupName:'群名称',
    userCount:'群人数',

    tableText1:'今日消息数',
    tableText2:'今日活跃人数',
    tableText3:'今日群流水',
    tableText4:'总群流水',

    tableText5:'发言次数',
    tableText6:'群流水',

    switchImg:'更换图片',
    introduction:'群组介绍',
    labels:'群标签',
    blackList:'黑名单',

    btnText1:'查看详情',
    btnText2:'踢出群组',
    btnText3:'踢出群组并拉黑',
    addTime:'创建时间',
    banGroup:'封禁群组',

    banAction:'封禁',
    unBan:'解除封禁',

    identity:'身份',

    formText1:'请输入群组拥有者ID',
    sort:'排序',
    question:'问题',

    addQuestion:'新建问题',

    dissolution:'解散群组',

  }
}



// WEBPACK FOOTER //
// ./src/language/groupManagement-zh-cn.js